(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram"] && !Shopify.designMode) return;
  try {
    
var $target = $("#instafeed-new");
$target.instagramLite({
  accessToken: $target.data('client-id'),
  urls: true,
  videos: true,
  limit: $target.data('count'),
  success: function(){
    if(!theme.cache.$html.hasClass('lt-ie9')) {
      enquire.register(theme.variables.mediaQueryMediumDown, {
        match: function() {
          // Init instagram slider
          $target.slick({
            centerMode: true,
            infinite: true,
            centerPadding: '12%',
            slidesToShow: 1,
            slidesToScroll: 1,
          });
        },
        unmatch: function() {
          // Destroy instagram slider
          $target.slick('unslick');
        }
      });
    }
  },
  error: function(errorCode, errorMessage) {
    if(errorCode && errorMessage) {
      alert(errorCode +': '+ errorMessage);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-review-template"]) return;
  try {
    
var $target = $("#instafeed-review");
$target.instagramLite({
  accessToken: $target.data('client-id'),
  urls: true,
  videos: true,
  limit: $target.data('count'),
  success: function(){
    
  },
  error: function(errorCode, errorMessage) {
    if(errorCode && errorMessage) {
      alert(errorCode +': '+ errorMessage);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-instagram"] && !Shopify.designMode) return;
  try {
    
// wait for jQuery
var interval = setInterval(function() {
  if (typeof $ != 'undefined') {
    runScript();
    clearInterval(interval);
  }
}, 100);

function runScript()
{
  jQuery(document).ready(function(){
  var $target_new = $("#instafeed-new");
  if(!theme.cache.$html.hasClass('lt-ie9')) {
    enquire.register(theme.variables.mediaQueryMediumDown, {
      match: function() {
        // Init instagram slider
        $target_new.slick({
          centerMode: true,
          infinite: true,
          centerPadding: '12%',
          slidesToShow: 1,
          slidesToScroll: 1,
        });
      },
      unmatch: function() {
        // Destroy instagram slider
        $target_new.slick('unslick');
      }
    });
  }
  });
}

  } catch(e) { console.error(e); }
})();
})();
